import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  btn: {
    display: 'inline-block',
    cursor: 'pointer',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    padding: '5px 20px',
    textTransform: 'uppercase',
    textDecoration: 'none',
    boxShadow: `inset 0px 0px 0px 0px ${theme.palette.primary.main}`,
    transition: 'box-shadow 0.2s ease-in-out',
    [theme.breakpoints.up('md')]: {
      padding: '15px 42px',
    },
    '&:hover': {
      boxShadow: `inset 0px 0px 0px 3px ${theme.palette.primary.main}`,
    },
  },
  uppercase: {
    textTransform: 'uppercase',
  },
});

function ButtonOutlineDark(props) {
  const { classes, link, icon, text } = props;
  return (
    <Link to={link} className={classes.btn}>
      <Box component="span" display="flex" alignItems="center">
        <Typography
          component="span"
          variant="button"
          className={classes.uppercase}
        >
          {text}
        </Typography>
        {icon && (
          <Box display="flex" alignItems="center" ml={2}>
            {icon}
          </Box>
        )}
      </Box>
    </Link>
  );
}

ButtonOutlineDark.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string.isRequired,
  icon: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ButtonOutlineDark);
